export const CATEGORY_ALL_COVER_IMAGE_URL =
  'https://hashimoto.fra1.cdn.digitaloceanspaces.com/cookbook/covers/categoryAll.jpg';
export const CATEGORY_ALL_NAME = 'cookbook.mealCategoryThumb.allMealsTitle';
